export default function SolarServices() {
  const services = [
    {
      icon: 'ri-sun-line',
      title: 'Residential Solar Installation',
      description: 'Complete rooftop solar panel systems designed for homes, including panels, inverters, and battery storage for maximum energy independence'
    },
    {
      icon: 'ri-building-line',
      title: 'Commercial Solar Systems',
      description: 'Large-scale solar installations for businesses and commercial properties to reduce operating costs and meet sustainability goals'
    },
    {
      icon: 'ri-battery-charge-line',
      title: 'Solar Battery Storage',
      description: 'Energy storage solutions that store excess solar power for use during peak hours, outages, or nighttime consumption'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Solar Energy Audits',
      description: 'Professional assessment of your property to determine solar potential, system sizing, and projected energy savings'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Solar Maintenance & Repair',
      description: 'Ongoing maintenance, cleaning, monitoring, and repair services to ensure optimal solar system performance and longevity'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Incentive & Permit Assistance',
      description: 'Help navigating federal tax credits, state incentives, net metering programs, and local permitting requirements'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Comprehensive Solar Energy Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From initial consultation to installation and maintenance, our network of solar contractors provides complete renewable energy solutions for El Paso
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-amber-500 text-white rounded-lg mb-6">
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
